import { gql } from "@apollo/client";

export const packagesQuery = gql`
    query Packages($page: Int, $sort: SortInput, $query: String, $country: String, $type: PackageType) {
        packages(page: $page, sort: $sort, query: $query, country: $country, type: $type) {
            nodes {
                id
                name
                description
                country
                validTimeInMonths
                type
                createdAt
            }
            totalCount
            nextPage
            previousPage
            totalPages
        }
    }
`;
